import ArtifactGroupType from "../base/ArtifactGroupType";


const EccentricFlint = {
  id: '146',
  name: 'Eccentric Flint',
  groupIcon: 'UnderTheCeiba',
  type: ArtifactGroupType.UNDER_THE_CEIBA,
  icon: 'EccentricFlint',
  power: 10,
  gameId: 'EccentricFlint'
};

export default EccentricFlint;
